export const PRODUCTION = process.env.NODE_ENV === 'production'
export const DEVELOPMENT = process.env.NODE_ENV === 'development'

export const CDN_URL = process.env.GATSBY_CDN_URL
export const API_URL = process.env.GATSBY_API_URL
export const ADS_ENABLED = process.env.GATSBY_ADS_ENABLED === 'true'
